import { Box, CircularProgress } from "@material-ui/core"
import { makeStyles } from '@material-ui/styles'
const useStyles = makeStyles( theme => ({
    root: {
        background: theme.palette.background.defaultPrimary,
        minHeight: '100vh',
    }
    
}));

const AuthLoading = () => {
    const classes = useStyles()
    return (
        <Box className={classes.root} display="flex">
            <Box m="auto">
                <CircularProgress />
            </Box>
        </Box>
    )
}

export default AuthLoading
